import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S3-WB1
// (PRA-789). Now served by `api-core-node` at
// `GET /api/firms/arag/cases?view=member-id`. See `signIntoArag.ts` for the
// retirement-deferred callable note.

export const getAragCasesByMemberIdRoute = {
  transport: 'api',
  method: 'GET',
  path: '/firms/arag/cases',
  query: (requestData) => ({
    ...requestData,
    view: 'member-id',
  }),
} as const satisfies BackendRouteDefinition;
